import { render, staticRenderFns } from "./SlideSearch.vue?vue&type=template&id=2c8632c6&scoped=true&"
import script from "./SlideSearch.vue?vue&type=script&lang=js&"
export * from "./SlideSearch.vue?vue&type=script&lang=js&"
import style0 from "./SlideSearch.vue?vue&type=style&index=0&id=2c8632c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8632c6",
  null
  
)

export default component.exports